import axios from "axios";
import { del, get, post, patch,  put } from "./exam_rooms_api_helper";
import * as url from "./exam_rooms_url_helper";



export const getExamRooms = () => get(url.GET_EXAM_ROOMS);



export const addNewExamRoom = (examRoom) => post(url.ADD_NEW_EXAM_ROOM, examRoom);

export const updateExamRoom = (examRoom) => patch(`${url.UPDATE_EXAM_ROOM}/${examRoom.uuid}`,  examRoom);

export const deleteExamRoom = (examRoom) => del(`${url.DELETE_EXAM_ROOM}/${examRoom.uuid}`);


export const checkExamRoomAvailability  = (data)   => post(url.CHECK_AVAILABILITY, data);






